/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Minimum_Feature_4Inputs */

const et_plan_minimum_feature_4 = /** @type {(inputs: Plan_Minimum_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piiratud veebi optimeerimine`)
};

const en_plan_minimum_feature_4 = /** @type {(inputs: Plan_Minimum_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited web optimization`)
};

/**
* | output |
* | --- |
* | "Limited web optimization" |
*
* @param {Plan_Minimum_Feature_4Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_minimum_feature_4 = /** @type {((inputs?: Plan_Minimum_Feature_4Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Minimum_Feature_4Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_minimum_feature_4(inputs)
	return en_plan_minimum_feature_4(inputs)
});